import { render, staticRenderFns } from "./Mobile.vue?vue&type=template&id=75aff72f&scoped=true&"
import script from "./Mobile.vue?vue&type=script&lang=js&"
export * from "./Mobile.vue?vue&type=script&lang=js&"
import style0 from "./Mobile.vue?vue&type=style&index=0&id=75aff72f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aff72f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HomeMobileTileCard: require('/usr/src/motec/components/home/MobileTileCard.vue').default,HomeMobileFeaturedCard: require('/usr/src/motec/components/home/MobileFeaturedCard.vue').default})
